/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// Crée un cookie à partir d'un nom, d'une valeur, d'une durée avant expiration en jour, d'un path et d'un domaine
function createCookie(name,value,days, path_arg, domain_arg) {
    var path = path_arg || '/';
    var domain = domain_arg || '.mnhn.fr';
    var expires = "";

    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));//12 mois
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; domain="+domain+"; path="+path;
}

// Lit le contenu d'un cookie en donnant son nom
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
        
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

// Supprime un cookie en donnant son nom 
function eraseCookie(name) {
        createCookie(name,"",-1);
}

// Supprime les cookies des sites CMS
function suppress_geco_cookies() {
    var $dom;
    stringtotr = document.cookie.split(';');
    for (i=0;i<stringtotr.length;i++){
        // suppression du caractère vide souvent présent en début de string //
        while (stringtotr[i].charAt(0)==' '){ 
            stringtotr[i] = stringtotr[i].substring(1,stringtotr[i].length);
        }
        cookie_liste = stringtotr[i].substring(0, stringtotr[i].lastIndexOf('='));
        if (/^geco/.test(cookie_liste)) {
            //console.log (cookie_liste);
            eraseCookie(cookie_liste);
        }
        if (/^wordpress/.test(cookie_liste)) {
            //console.log (cookie_liste);
            $dom = window.location.hostname;
            createCookie(cookie_liste,"",-1,"/",$dom);
        }
        if (/^wp-settings/.test(cookie_liste)) {
            //console.log (cookie_liste);
            $dom = window.location.hostname;
            createCookie(cookie_liste,"",-1,undefined,$dom);
        }
    }
    eraseCookie('cookie_consentement');
    eraseCookie('_ga');
    eraseCookie('_gat');
    createCookie("nf_wp_session","",-1,"/",$dom);
    createCookie("cookie_eu_message","",-1,undefined,"www.mnhn.fr");
}

// Deux fonctions qui cachent le bandeau d'infos sur les cookies
function move(elem) {
            var top = 0;
            function frame() {
                top--;  // update parameters
                document.getElementById(elem).style.top = top + 'px'; // show frame
                if (top === -40){  // check finish condition, à paramétrer selon le site
                    clearInterval(id);
                    // cache le bandeau dont l'id de la div est à paramétrer
                    hide_visibility('cookies_warning');
                }
            }
            var id = setInterval(frame, 10); // draw every 10ms
        }
        
function ok_cookie (){
    createCookie('cookie_consentement','ok',365);
    move('cookies_warning');
}

// Fonction qui cache le bandeau des cookies quand on clique sur un lien du site
function cookie_callback(e_arg) {
    var e = window.e || e_arg;
    var el = e.target;
    if (el.tagName !== 'A' ){
        return;
    }
    // les liens qui ne doivent pas déclencher le consentement doivent avoir la classe 'nofire'
    if (el.className === 'nofire'){
        return;
    }
    ok_cookie();
}